<section class="content head">
  <div class="content-wrapper audit-list">    
    <div class="audit-list__header">
      <h1>History of {{capaTableData?.historyTitle}}</h1> 
      <p>There are {{capaTableData?.totalCount}} histories in this Audit.</p>
    </div>
    <div class="audit-list__actions"></div>
  </div>
</section>

<section class="content" *ngIf="hasInitialCapas">
  <div class="content-wrapper">
    <iaud-table 
        [data]="capaTableData" 
        [options]="capaTableOptions" 
        [forceReloadEvent]="forceReloadEvent"
        [dataRefreshCallback]="reloadCapaList.bind(this)" 
        [dataEditCallback]="capaDetailClick.bind(this)"
        [dataDeleteCallback]="deleteData.bind(this)" 
        [deleteTitle]="'Delete CAPA'"
        [deleteText]="'Are you sure you want to delete ${data.capaTitle} CAPA?'">
    </iaud-table>
  </div>
</section>

<ng-template #evidenceRights let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngIf="detailData.item[detailOption.fieldName]">All CAPA/EC PICs required to submit</p>
  <p [id]="detailOption.fieldName" *ngIf="!detailData.item[detailOption.fieldName]">Only one of CAPA/EC PICs required to submit</p>
</ng-template>

<ng-template #statusCellTemplate let-rowData="rowData">
  <iaud-audit-capa-status [status]="rowData.status"></iaud-audit-capa-status>
</ng-template>

<ng-template #picsDetailTemplate let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngFor="let pic of detailData.item[detailOption.fieldName]">
    {{ pic.fullName }}
  </p>
</ng-template>